export function validatePhoneNumber(number, country, contact2 = false) {
    let num = number == null ? "" : String(number).trim();



    if (contact2 === true && num.length === 0) {
        return { valid: true, reason: "" };
    }

    if (num.length > 0) {
        if ([null, undefined, ""].includes(country)) {
            return { valid: false, reason: "Country code required" };
        }

    }
    // Remove leading 0 if present
    if (num.startsWith("0")) {
        num = num.slice(1);
    }

    // Check if the string is numeric only
    if (!/^\d+$/.test(num)) {

        if (num.length > 0) {
            return {
                valid: false,
                reason: "contact number contains invalid characters"
            };
        }

    }

    if (country === 13) {
        // South Africa
        const isValid = num.length === 9;
        return {
            valid: isValid,
            reason: isValid ? "" : "invalid contact number"
        };
    }

    if (country === 65) {
        // Lesotho
        const isValid = num.length === 8;
        return {
            valid: isValid,
            reason: isValid ? "" : "invalid Lesotho contact number"
        };
    }



    // Default: unknown country, assume valid
    return {
        valid: true,
        reason: ""
    };
}